import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Overview/Using with React";
import * as React from 'react';
export default {
  Content,
  React
};